<template>
  <div>
    <div class="cut-btn">
      <el-button
        size="medium"
        plain
        type="primary"
        @click="changeScale(1)"
        icon="el-icon-zoom-in"
      ></el-button>
      <el-button
        size="medium"
        plain
        type="primary"
        @click="changeScale(-1)"
        icon="el-icon-zoom-out"
      ></el-button>
      <el-button
        size="medium"
        plain
        type="primary"
        @click="rotateLeft"
        icon="el-icon-refresh-left"
      ></el-button>
      <el-button
        size="medium"
        plain
        type="primary"
        @click="rotateRight"
        icon="el-icon-refresh-right"
      ></el-button>
    </div>
    <div class="cut">
      <div :style="'width:' + width + 'px;' + 'height:' + height + 'px;'">
        <!--  -->
        <vue-cropper
          ref="cropper"
          :img="optionImg"
          :output-size="option.size"
          :output-type="option.outputType"
          :info="true"
          :full="option.full"
          :fixed="fixed"
          :fixed-number="fixedNum"
          :can-move="option.canMove"
          :can-move-box="option.canMoveBox"
          :fixed-box="option.fixedBox"
          :original="option.original"
          :auto-crop="option.autoCrop"
          :auto-crop-width="cutWidth"
          :auto-crop-height="cutHeight"
          :center-box="option.centerBox"
          @real-time="realTime"
          :high="option.high"
          @img-load="imgLoad"
          mode="cover"
          :max-img-size="option.max"
          @crop-moving="cropMoving"
          style="background-image: none; background: #eee"
        >
        </vue-cropper>
      </div>

      <div
        class="show-preview"
        :style="{
          width: previews.w + 'px',
          height: previews.h + 'px',
          overflow: 'hidden',
        }"
      >
        <div :style="previews.div">
          <img :src="previews.url" :style="previews.img" />
        </div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button plain @click="cancelCut">取消</el-button>
      <el-button type="primary" @click="handleUpolad">确定</el-button>
    </div>
  </div>
</template>
<script>
// import { getStorage } from '@/util/localStor'
import { VueCropper } from "vue-cropper";
export default {
  components: { VueCropper },
  props: [
    "width",
    "height",
    "optionImg",
    "fileName",
    "fixed",
    "fixedNum",
    "cutWidth",
    "cutHeight",
    "from",
  ],

  data() {
    return {
      previews: {},

      option: {
        img: "",
        size: 1,
        full: false,
        outputType: "png",
        canMove: true,
        fixedBox: false,
        original: false,
        canMoveBox: true,
        autoCrop: true,
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 750,
        autoCropHeight: 340,
        centerBox: true,
        high: true,
        max: 99999,
      },
      show: true,
      // fixed: false,
      fixedNumber: [1, 1],
    };
  },
  methods: {
    cancelCut() {
      this.$emit("cancelCut");
      this.previews = {};
      // this.option.img = ''
    },
    // 传图
    handleUpolad() {
      let formdata = new FormData();

      this.$refs.cropper.getCropBlob((data) => {
        // if(this.from=='part'){
        //   formdata.append("partCode",getStorage('partData').partCode)
        // }
        formdata.append("file", data, this.fileName);
        // console.log(data,'----blob111111111111')
        this.$emit("confirmCut", formdata, this.previews);
        //   this.submitImg(formdata)
      });
      // }
    },
    base64toFile(data, fileName) {
      const dataArr = data.split(",");
      const byteString = atob(dataArr[1]);
      const options = {
        type: "image/jpeg",
        endings: "native",
      };
      const u8Arr = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        u8Arr[i] = byteString.charCodeAt(i);
      }
      return new File([u8Arr], fileName + ".jpg", options); //返回文件流
    },
    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },
    rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },

    // 实时预览函数
    realTime(data) {
      this.previews = data;
    },
    imgLoad(msg) {
      // console.log(msg)
    },
    cropMoving(data) {
      // console.log(data, '截图框当前坐标')
    },
  },
};
</script>
<style lang="scss" scoped>
.cut {
  display: flex;
  align-items: center;
  justify-content: center;
  .show-preview {
    margin-left: 30px;
  }
}
.btn {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #c0ccda;
  color: #1f2d3d;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 20px 10px 0px 0px;
  padding: 9px 15px;
  font-size: 14px;
  border-radius: 4px;
  color: #fff;
  background-color: var(--theme-color);
  border-color: var(--theme-color);
  transition: all 0.2s ease;
  text-decoration: none;
  user-select: none;
}
.cut-btn {
  margin-bottom: 15px;
  display: flex;
}
.dialog-footer {
  text-align: center;
  padding: 12px;
}
</style>
